import {
  Dialog,
  DialogBody,
  DialogButton,
  DialogButtons,
  DialogCloseX,
  DialogContent,
  DialogHeading,
} from "@tandemdiabetes/sugarmate-react-components"
import type { MouseEventHandler } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  open: boolean;
  setOpen: (o: boolean) => void;
  disable: MouseEventHandler<HTMLButtonElement>;
}

const polyglotPrefix = "pages.account.follow_only.dialog."

/*
 * renders a dialog asking the user to confirm that they want to disable follow-only mode
 */
export function DisableFollowOnlyDialog(props: Props) {
  const {
    setOpen,
    open: isOpen,
    disable,
  } = props

  const polyglot = usePolyglot()

  return (
    <Dialog
      open={isOpen}
      onOpenChange={setOpen}
    >
      <DialogContent>
        <DialogHeading>
          {polyglot.t(`${polyglotPrefix}title`)}
          <DialogCloseX />
        </DialogHeading>
        <DialogBody>
          {polyglot.t(`${polyglotPrefix}body`)}
        </DialogBody>
        <DialogButtons>
          <DialogButton
            stylePreset="secondary"
          >
            {polyglot.t(`${polyglotPrefix}cancel_cta`)}
          </DialogButton>
          <DialogButton
            stylePreset="primary"
            onClick={disable}
            id="confirm-disable"
          >
            {polyglot.t(`${polyglotPrefix}confirm_cta`)}
          </DialogButton>
        </DialogButtons>
      </DialogContent>
    </Dialog>
  )
}
